// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  exchangeRateRequest: ['data'],
  exchangeRateSuccess: ['data'],
  exchangeRateFailure: ['err'],
  
  exchangeRateSingleRequest: ['data'],
  exchangeRateSingleSuccess: ['data'],
  exchangeRateSingleFailure: ['err'],

  exchangeRateUpdateRequest: ['data'],
  exchangeRateUpdateSuccess: ['data'],
  exchangeRateUpdateFailure: ['err'],
})

export const ExchangeRateTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  detail: {},
  err: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const successSingle = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    detail: data,
    err: null
  })

export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    err: null
  })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.EXCHANGE_RATE_SUCCESS]: success,
  [Types.EXCHANGE_RATE_REQUEST]: request,
  [Types.EXCHANGE_RATE_FAILURE]: failure,

  [Types.EXCHANGE_RATE_SINGLE_SUCCESS]: successSingle,
  [Types.EXCHANGE_RATE_SINGLE_REQUEST]: request,
  [Types.EXCHANGE_RATE_SINGLE_FAILURE]: failure,

  [Types.EXCHANGE_RATE_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.EXCHANGE_RATE_UPDATE_REQUEST]: request,
  [Types.EXCHANGE_RATE_UPDATE_FAILURE]: failure,
})



// WEBPACK FOOTER //
// ./src/Redux/ExchangeRateRedux.js